.reactSelectWrapper {
  margin-top: 0.3125rem;

  >div:nth-child(3) {
    background-color: #f7f8f9;
    border: 0.0625rem solid #8e9092;
    border-radius: 0.25rem;
    color: #333;
    font-size: 1rem;
    line-height: 1.375rem;
    min-height: 3.125rem;
    width: 100%;
    min-width: 5rem;

    &:focus-within {
      border-color: #006fcf !important;
      box-shadow: none !important;
    }
  }
}

.errorBorder {
  >div:nth-child(3) {
    border-color: #b42c01;
  }
}